import * as React from 'react';
import { useBOMStore } from 'src/hooks/bom';
import { useCartStore } from 'src/hooks/cart';
import System from 'src/helper/system';
import Constants from 'src/helper/Constants';

const BomToCartItemReplacePopup = (props) => {
    const { SetStatus, data } = props;
    let cartReplaceItem = data.cartReplaceItem
    let validBomDetailId = data.validBomDetailId
    let isFrom = data?.isFrom || ''
    const [{ }, { }, { replace_cart_in_Bulk }] = useCartStore();
    const [{ }, { }, { USERS_WITH_ABANDONED_BOM_FOR_72_HOURS }] = useBOMStore();
    const { translation:t } = System;

    const replaceCartItem = async () => {
        await replace_cart_in_Bulk(cartReplaceItem, true);
        //api call only for BomToCart case
        if (isFrom !== Constants.systemModules.ORDER) {
            USERS_WITH_ABANDONED_BOM_FOR_72_HOURS(validBomDetailId)
        }
    }

    return (
        <>
            <div className="avnet-modal modal-680">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={() => {
                            SetStatus(false)
                        }}>×
                    </button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="pcn-modal-heading pl-5">{t('customerPartNumber')}</h3>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body">
                        <p>{t('thereAreDuplicateItemsInYourCart')}</p>
                    </div>

                    {/* Modal footer */}
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary minw-auto"
                                data-bs-toggle="modal"
                                onClick={() => {
                                    SetStatus(false)
                                }}>
                                {t('cancel')}
                            </button>
                            <button type="submit" className="bs5 btn btn-primary minw-auto"
                                data-bs-toggle="modal"
                                onClick={() => {
                                    replaceCartItem()
                                }}>
                                {t('replace')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default BomToCartItemReplacePopup;